module.exports = __webpack_public_path__ + "img/pleasure-icon-1.8fbfac45.svg";